export default __webpack_public_path__ + "images/2df55531c6924b55f21c4cf5d4484680-logo-light.svg";